import {
  WrapPage,
  Loading,
  Toast,
  PaginationProps,
  Pagination,
} from 'common/ui'
import CreateDAppBtn from '@/component/CreateDAppBtn'
import styled from 'styled-components'
import { appConfig, DAPP_PAGE_SIZE } from '@/constants'
import { useEffect, useState } from 'react'
import { address as getAddressService } from 'common/api'
import { useThrottle, useDioxAddressContext } from 'common/hooks'
import { useMemo } from 'react'
import DAppCard from '@/component/DAppCard'
import { DIOX } from 'common/api'
import { NextPageContext } from 'next'

const addressService = getAddressService()
const HomeStyled = styled.div`
  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    transform: translateY(-50%);
    img {
      width: 200px;
      height: 200px;
      margin-bottom: 4px;
    }
    p {
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: #a3a3a3;
      margin-bottom: 48px;
    }
    button {
      font-weight: 600;
      width: 164px;
    }
  }
  .list-box {
    display: grid;
    grid-gap: 24px;
    grid-template-columns: repeat(3, 1fr);
    margin-bottom: 24px;
  }
  .header {
    margin-bottom: 20px;
    padding-top: 34px;
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    z-index: 2;
    .title {
      font-weight: 700;
      font-size: 24px;
      line-height: 30px;
      color: #ffffff;
    }
    button {
      width: 141px;
      height: 40px;
      padding: 0;
    }
  }
`

const Home = ({
  pageProps = {},
}: {
  pageProps: { DApps?: DIOX.DAppSummary[] }
}) => {
  const { address } = useDioxAddressContext()
  const [DApps, setDApps] = useState<Array<DIOX.DAppSummary>>(
    pageProps.DApps || []
  )
  const [loading, setLoading] = useState(true)
  const [cacheAddr, setCacheAddr] = useState<string | null>(null)
  const [total, setTotal] = useState<number>(0)
  const [pos, setpos] = useState(0)

  useEffect(() => {
    // 地址会刷新两次，第一次是基本信息，第二次是balance和metadata
    if (cacheAddr !== address) {
      setCacheAddr(address?.address || null)
    }
  }, [address, cacheAddr])

  useEffect(() => {
    getAddressDAppsList()
  }, [cacheAddr])

  useEffect(() => {
    getAddressDAppsList()
  }, [pos])

  const paginationOption = useMemo<PaginationProps>(
    () => ({
      current: pos + 1,
      pageSize: DAPP_PAGE_SIZE,
      total: total,
      onPageChange: (current) => setpos(current - 1),
    }),
    [total, pos]
  )

  const getAddressDAppsList = useThrottle(async () => {
    const addr = address?.address
    if (!addr) return
    setLoading(true)
    try {
      const { Result } = await addressService.getAddressDAppsList(addr, {
        limit: DAPP_PAGE_SIZE,
        pos: pos * DAPP_PAGE_SIZE,
      })
      const { ListData, TotalNum } = Result || {}
      setDApps(ListData || [])
      setTotal(TotalNum || 0)
    } catch (e: any) {
      setDApps([])
      Toast({ text: e?.message })
    }
    setLoading(false)
  }, 500)

  const isEmpty = useMemo(() => {
    return !DApps.length
  }, [DApps])

  return (
    <HomeStyled>
      {loading ? (
        <div className="empty">
          <Loading />
        </div>
      ) : (
        <>
          <div className="header">
            <h3 className="title">My DApps</h3>
            {!isEmpty && (
              <CreateDAppBtn icon="create-token">Create DApp</CreateDAppBtn>
            )}
          </div>
          {isEmpty ? (
            <div className="empty">
              <img src="/img/list-empty.png" alt="empty" />
              <p>You haven‘t created a DApp yet.</p>
              <CreateDAppBtn>Create DApp</CreateDAppBtn>
            </div>
          ) : (
            <>
              <div className="list-box">
                {DApps.map((token) => (
                  <DAppCard data={token} key={token.ID} />
                ))}
              </div>
              {total > DAPP_PAGE_SIZE && (
                <Pagination className="mt-[32px]" {...paginationOption} />
              )}
            </>
          )}
        </>
      )}
    </HomeStyled>
  )
}

// Home.getInitialProps = async (ctx: NextPageContext) => {
//   const pageProps: { [key: string]: any } = {}
//   const cacheAddress = (ctx.req as any)?.cookies?.cacheAddress

//   try {
//     if (cacheAddress) {
//       const addr = JSON.parse(cacheAddress).address
//       const { Result } = await addressService.getAddressDAppsList(addr, {
//         limit: DAPP_PAGE_SIZE,
//         pos: 0 * DAPP_PAGE_SIZE,
//       })
//       const { ListData } = Result || {}
//       pageProps.DApps = ListData || []
//     }
//     return { pageProps }
//   } catch (err) {
//     return { ...pageProps }
//   }
// }

export default WrapPage(Home, appConfig)
